export const MsalLogoutRequest = { onRedirectNavigate: () => false }
